import * as React from 'react';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import "./loading.css";

export default function Loading() {
  return (
    <div className="loader"></div>
  );
}

